module.exports = __webpack_public_path__ + "static/media/1_en.9c3a5777.png";